import { SummarizerConfig } from '../../types/summarizer';

export const tiktokTranscriptConfig: SummarizerConfig = {
  // Basic identification
  id: 'tiktok-transcript',
  title: 'TikTok Transcript Generator',
  outputTitle: 'TikTok Video Transcript',
  description: 'Get accurate transcripts from TikTok videos with AI-powered chat',
  version: '1.0.0',

  // Categorization
  category: 'social',
  tags: ['tiktok', 'transcript', 'social-media', 'video', 'short-form'],

  // Input configuration
  inputs: {
    file: {
      enabled: false, // TikTok is URL-based
    },
    url: {
      enabled: true,
      placeholder: 'Enter TikTok video URL (e.g., https://www.tiktok.com/@user/video/...)',
      validation:
        /(?:https?:\/\/)?(?:www\.)?(?:tiktok\.com\/@[^/]+\/video\/\d+|vm\.tiktok\.com\/[a-zA-Z0-9]+|tiktok\.com\/t\/[a-zA-Z0-9]+)/,
      examples: [
        'https://www.tiktok.com/@username/video/1234567890123456789',
        'https://vm.tiktok.com/ZMexample/',
        'https://www.tiktok.com/t/ZTexample/',
      ],
      helpText:
        'Paste any TikTok video URL to get an accurate transcript and chat with AI about the content.',
      showExamples: true,
      showHelpText: true,
    },
    submitButtonText: 'Get Transcript',
  },

  // Output features - ONLY transcript and chat enabled per requirements
  outputs: {
    summary: false,
    chat: true, // Ask follow-up questions enabled
    mindmap: false,
    translation: false,
    keyPoints: false,
    transcript: true, // Transcript enabled
    download: true, // Allow downloading transcript
    share: false,
    repurpose: false,
    // Custom tab order: Transcript first, then Chat
    tabsOrder: ['transcript', 'chat', 'download'],
    // Custom label for better UX
    summaryTabLabel: 'Transcript',
  },

  // Backend integration
  api: {
    endpoint: '/summarize',
    method: 'POST',
    contentType: 'tiktok', // TikTok content type as specified
    timeout: 60000, // 60 seconds for video processing
  },

  // UI customization (Level 1: Basic styling)
  ui: {
    primaryColor: '#000000', // TikTok black
    secondaryColor: '#fe2c55', // TikTok pink/red
    icon: '🎵',
    theme: 'light',
    // Custom loading messages for TikTok content
    loadingMessages: {
      aiGeneration: {
        title: 'AI is transcribing your TikTok video...',
        subtitle: 'Processing video audio, generating accurate transcript, and preparing AI chat.',
      },
      translation: {
        title: 'Processing TikTok content...',
        subtitle: 'Extracting and transcribing audio from the TikTok video.',
      },
      streaming: {
        indicator: 'Generating transcript...',
      },
    },
  },

  // Validation rules
  validation: {
    required: true,
    allowedDomains: ['tiktok.com', 'www.tiktok.com', 'vm.tiktok.com'],
    blockedDomains: [],
  },

  // Feature flags
  features: {
    beta: false,
    premium: false,
    experimental: false,
  },

  // Metadata
  author: 'TubeOnAI',
  createdAt: '2024-01-01',
  updatedAt: '2024-01-01',
};
